export enum ChartAxisDirection {
    X = 'x',
    Y = 'y',
    Angle = 'angle',
    Radius = 'radius',
}

export type CartesianAxisDirection = ChartAxisDirection.X | ChartAxisDirection.Y;
